export const PROPERTIES_LIST_REQUEST ='PROPERTIES_LIST_REQUEST'
export const PROPERTIES_LIST_SUCCESS ='PROPERTIES_LIST_SUCCESS'
export const PROPERTIES_LIST_FAIL ='PROPERTIES_LIST_FAIL'

export const ADD_PROPERTIES_REQUEST ='ADD_PROPERTIES_REQUEST'
export const ADD_PROPERTIES_SUCCESS ='ADD_PROPERTIES_SUCCESS'
export const ADD_PROPERTIES_FAIL ='ADD_PROPERTIES_FAIL'
export const ADD_PROPERTIES_RESET='ADD_PROPERTIES_RESET'

export const DELETE_PROPERTIES_REQUEST ='DELETE_PROPERTIES_REQUEST'
export const DELETE_PROPERTIES_SUCCESS ='DELETE_PROPERTIES_SUCCESS'
export const DELETE_PROPERTIES_FAIL ='DELETE_PROPERTIES_FAIL'
export const DELETE_PROPERTIES_RESET ='DELETE_PROPERTIES_RESET'

export const PROPERTIES_DETAILS_REQUEST ='PROPERTIES_DETAILS_REQUEST'
export const PROPERTIES_DETAILS_SUCCESS ='PROPERTIES_DETAILS_SUCCESS'
export const PROPERTIES_DETAILS_FAIL ='PROPERTIES_DETAILS_FAIL'
export const PROPERTIES_DETAILS_RESET ='PROPERTIES_DETAILS_RESET'


export const UPDATE_PROPERTIES_REQUEST ='UPDATE_PROPERTIES_REQUEST'
export const UPDATE_PROPERTIES_SUCCESS ='UPDATE_PROPERTIES_SUCCESS'
export const UPDATE_PROPERTIES_FAIL ='UPDATE_PROPERTIES_FAIL'
export const UPDATE_PROPERTIES_RESET ='UPDATE_PROPERTIES_RESET'


export const ADD_ROOM_REQUEST ='ADD_ROOM_REQUEST'
export const ADD_ROOM_SUCCESS ='ADD_ROOM_SUCCESS'
export const ADD_ROOM_FAIL ='ADD_ROOM_FAIL'
export const ADD_ROOM_RESET='ADD_ROOM_RESET'

export const ROOM_DETAILS_REQUEST ='ROOM_DETAILS_REQUEST'
export const ROOM_DETAILS_SUCCESS ='ROOM_DETAILS_SUCCESS'
export const ROOM_DETAILS_FAIL ='ROOM_DETAILS_FAIL'
export const ROOM_DETAILS_RESET ='ROOM_DETAILS_RESET'

export const GET_ROOMS_DETAILS_REQUEST ='GET_ROOMS_DETAILS_REQUEST'
export const GET_ROOMS_DETAILS_SUCCESS ='GET_ROOMS_DETAILS_SUCCESS'
export const GET_ROOMS_DETAILS_FAIL ='GET_ROOMS_DETAILS_FAIL'
export const GET_ROOMS_DETAILS_RESET ='GET_ROOMS_DETAILS_RESET'

export const DELETE_ROOM_REQUEST ='DELETE_ROOM_REQUEST'
export const DELETE_ROOM_SUCCESS ='DELETE_ROOM_SUCCESS'
export const DELETE_ROOM_FAIL ='DELETE_ROOM_FAIL'
export const DELETE_ROOM_RESET ='DELETE_ROOM_RESET'

export const UPDATE_ROOM_REQUEST ='UPDATE_ROOM_REQUEST'
export const UPDATE_ROOM_SUCCESS ='UPDATE_ROOM_SUCCESS'
export const UPDATE_ROOM_FAIL ='UPDATE_ROOM_FAIL'
export const UPDATE_ROOM_RESET ='UPDATE_ROOM_RESET'

export const CHECK_PROPERTIES_REQUEST ='CHECK_PROPERTIES_REQUEST'
export const CHECK_PROPERTIES_SUCCESS ='CHECK_PROPERTIES_SUCCESS'
export const CHECK_PROPERTIES_FAIL ='CHECK_PROPERTIES_FAIL'
export const CHECK_PROPERTIES_RESET='CHECK_PROPERTIES_RESET'

export const CHECK_PROPERty_REQUEST ='CHECK_PROPERty_REQUEST'
export const CHECK_PROPERty_SUCCESS ='CHECK_PROPERty_SUCCESS'
export const CHECK_PROPERty_FAIL ='CHECK_PROPERty_FAIL'
export const CHECK_PROPERty_RESET='CHECK_PROPERty_RESET'


export const CONFIRM_BOOING_REQUEST ='CONFIRM_BOOING_REQUEST'
export const CONFIRM_BOOING_SUCCESS ='CONFIRM_BOOING_SUCCESS'
export const CONFIRM_BOOING_FAIL ='CONFIRM_BOOING_FAIL'
export const CONFIRM_BOOING_RESET='CONFIRM_BOOING_RESET'

export const CREATE_ACCOUNT_REQUEST ='CREATE_ACCOUNT_REQUEST'
export const CREATE_ACCOUNT_SUCCESS ='CREATE_ACCOUNT_SUCCESS'
export const CREATE_ACCOUNT_FAIL ='CREATE_ACCOUNT_FAIL'
export const CREATE_ACCOUNT_RESET='CREATE_ACCOUNT_RESET'

export const USER_SIGNIN_REQUEST = 'USER_SIGNIN_REQUEST';
export const USER_SIGNIN_SUCCESS = 'USER_SIGNIN_SUCCESS';
export const USER_SIGNIN_FAIL = 'USER_SIGNIN_FAIL';

export const USER_SIGNOUT = 'USER_SIGNOUT';

export const URL = 'https://tawi-backend.herokuapp.com'


export const DELETE_PROPIMG_REQUEST ='DELETE_PROPIMG_REQUEST'
export const DELETE_PROPIMG_SUCCESS ='DELETE_PROPIMG_SUCCESS'
export const DELETE_PROPIMG_FAIL ='DELETE_PROPIMG_FAIL'
export const DELETE_PROPIMG_RESET ='DELETE_PROPIMG_RESET'

export const DELETE_ROOMIMG_REQUEST ='DELETE_ROOMIMG_REQUEST'
export const DELETE_ROOMIMG_SUCCESS ='DELETE_ROOMIMG_SUCCESS'
export const DELETE_ROOMIMG_FAIL ='DELETE_ROOMIMG_FAIL'
export const DELETE_ROOMIMG_RESET ='DELETE_ROOMIMG_RESET'